import type { Reducer } from 'react';
import type { ElementDetail, ElementDetailAction, SubmitElementDetail } from './types';
import { convertSubmitElementDetail2ElementDetail } from './utils';

export const postReferencesReducer: Reducer<ElementDetail | undefined, ElementDetailAction> = (state, action) => {
  switch (action.type) {
    case 'init': {
      return convertSubmitElementDetail2ElementDetail(action.value as SubmitElementDetail);
    }
    case 'reset': {
      return undefined;
    }
    case 'updateName': {
      return {
        ...state,
        name: action.value,
      };
    }
    case 'updateDescription': {
      return {
        ...state,
        description: action.value,
      };
    }
    case 'updateStyle': {
      return {
        ...state,
        style: action.value,
      };
    }
    case 'updateCategories': {
      return {
        ...state,
        category: action.value,
      };
    }
    case 'updateSeries': {
      return {
        ...state,
        series: action.value,
      };
    }
    case 'updateIntroduce': {
      return {
        ...state,
        introduce: action.value,
      };
    }
    case 'updateCreations': {
      return {
        ...state,
        creations: action.value,
      };
    }
    case 'updateAllowCopy': {
      return {
        ...state,
        allowCopy: action.value,
      };
    }
    case 'updateShareCopyCount': {
      return {
        ...state,
        shareCopyCount: action.value,
      };
    }
    case 'updateReactInfo': {
      return {
        ...state,
        reactInfo: action.value,
      };
    }
    default:
      return state;
  }
};
